<template>
  <div>
    <b-container fluid>
      <b-row align-v="center">
        <b-col :md="dataActive === 'sign-in' ? '8' : '4'">
          <div
            id="sign-in"
            :class="{ active: dataActive === 'sign-in' }"
            class="form-container sign-in-form"
          >
            <h2>{{ $t('pages.sign_in.title') }}</h2>
            <template v-if="dataActive === 'sign-in'">
              <ajax-login
                :success-route="successRoute"
                :close-modal="true"
                uri="api/public/login"
                ref-modal="sign-in-sign-up-modal"
              />
              <router-link :to="{ name: 'password.request' }">{{ $t('form.forgotten_password') }}</router-link>
            </template>
            <template v-else>
              <a href="#" @click="setActive('sign-in')">{{ $t('pages.sign_in.to_do') }}</a>
            </template>
          </div>
        </b-col>
        <b-col :md="dataActive === 'sign-up' ? '8' : '4'">
          <div
            id="sign-up"
            :class="{ active: dataActive === 'sign-up' }"
            class="form-container sign-up-form"
          >
            <h2>{{ $t('pages.sign_up.title') }}</h2>
            <template v-if="dataActive === 'sign-up'">
              <div class="form">
                <ajax-new
                  :is-disabled="!hasAcceptedTOS"
                  :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
                  name="manager"
                  uri="api/public/manager"
                >
                  <div slot="beforeSubmit">
                    <b-form-checkbox
                      id="cgv"
                      v-model="terms"
                      :required="true"
                      @change="setHasAcceptedTOS($event)"
                    >
                      {{ $t('accept_terms_and_uses_1') }}
                      <a href="#" @click="openModal('cgv')">{{ $t('accept_terms_and_uses_2') }}</a>
                    </b-form-checkbox>
                  </div>
                </ajax-new>
              </div>
            </template>
            <template v-else>
              <a href="#" @click="setActive('sign-up')">{{ $t('pages.sign_up.to_do') }}</a>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import AjaxLogin from '@triotech/vue-core/src/components/authentification/AjaxLogin';
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';

  export default {
    name: 'SignFormComponent',
    components: {
      AjaxLogin,
      AjaxNew,
      'vue-form-generator': VueFormGenerator.component,
    },
    props: {
      active: {
        type: String,
        default: 'sign-in',
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        model: {},
        schema: {
          fields: [],
        },
        dataActive: null,
        terms: false,
        hasAcceptedTOS: false,
      };
    },
    async mounted() {
      this.dataActive = this.active;

      this.$bus.$on('t-event.t-modal.sign-in-sign-up-modal.open', (data) => {
        this.dataActive = data;
        const modal = this.$parent.$parent;
        // eslint-disable-next-line no-underscore-dangle
        this.$bus.$emit(`t-event.t-modal.${modal._uid}.open`);
      });

      this.$bus.$on('t-event.new-submit.manager.success', (data) => {
        this.$ajax.login({
          username: data.email,
          password: data.plain_password,
        }).then(() => {
          const modal = this.$parent.$parent;
          // eslint-disable-next-line no-underscore-dangle
          modal.$refs[`${modal._uid}_modal`].close();
          this.$router.push(this.successRoute());
        });
      });
    },
    methods: {
      openModal(id) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`);
      },
      setHasAcceptedTOS(state) {
        this.hasAcceptedTOS = state;
      },
      setActive(id) {
        this.dataActive = id;
      },
      successRoute() {
        let route = {};
        if (!this.get().oauth.user.memorial) {
          route = { name: 'parameter' };
        } else {
          route = {
            name: 'memorial.show',
            params: {
              id: this.get().oauth.user.memorial.id,
            },
          };
        }
        return route;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  @import 'compass/css3/transform';
  @import '~@triotech/vue-core/src/scss/compass';
  @import 'compass/css3/transition';
  @import '~@/scss/media';


  .form-container {
    padding: 2rem;
    background-color: $white;
    min-height: 130px;

    @include transition(height .2s);

    &.active {
      height: 500px;
      overflow: auto;
    }

    &:not(.active) {
      h2 {
        font-size: 1.4rem !important;
      }
    }

    &#sign-in {
      /deep/ .field-checkbox {
        display: flex;
        align-items: center;

        label {
          margin: 0;
        }
      }
    }
  }

  .custom-checkbox {
    margin-bottom: 15px;
  }

  @include editable-max-width(990px) {
    .form-container,
    .form-container.active {
      height: auto !important;
      @include transform(translateY(0));
    }
  }

  @include editable-max-width(600px) {
    #sign-in {
      &.active {
        padding-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SignForm.vue